import { render, staticRenderFns } from "./SingleMarketplaceAbout.vue?vue&type=template&id=6aa20a81&"
import script from "./SingleMarketplaceAbout.vue?vue&type=script&lang=js&"
export * from "./SingleMarketplaceAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports